import { Section } from '@/components/layout';
import { Sparkle } from '@/components/ornaments';
import { Reveal } from '@/components/motion';
import { DisplayTitle, Prose } from '@/components/typography';
import { AssetImage } from '@/pages/shared/AssetImage';
import { AZRAHEL } from '../hub.content';
import { HubCompassRose } from './HubCompassRose';
import styles from './HubAzrahel.module.css';

/**
 * Bloque "Azrahel del Mayor": retrato con mascara suave, nombre en dos pesos
 * opticos, bio y rosa de los vientos.
 *
 * El retrato sale SIEMPRE del material real de la marca (ADR-004 §1.1): la cara
 * que dibuja el mockup no es la del cliente y no se usa.
 *
 * COMPOSICION DEL POSTER, que es lo que se ha corregido en esta vuelta:
 *  · La banda va **a sangre con el cielo detras** (`hub/banda-cielo`), no sobre
 *    crema plano. El asset existia en el manifiesto y nadie lo estaba usando.
 *  · El retrato **sangra por el borde izquierdo** y por arriba.
 *  · El nombre va en **una linea** («AZRAHEL del Mayor») con un destello a la
 *    derecha, no en dos lineas con un filete dorado debajo.
 *  · La rosa de los vientos es un **ornamento protagonista** (`HubCompassRose`),
 *    no una marca de agua al 12 % de opacidad.
 */
export function HubAzrahel() {
  return (
    <Section
      background="none"
      spacing="flush"
      width="full"
      labelledBy="hub-azrahel-title"
      className={styles.azrahel}
      ornament={
        <AssetImage
          asset="hub/banda-cielo"
          className={styles.sky}
          sizes="100vw"
          alt=""
        />
      }
    >
      <div className={styles.grid}>
        <Reveal className={styles.portrait}>
          <AssetImage
            asset="azrahel/retrato"
            className={styles.portraitMedia}
            sizes="(min-width: 768px) 26vw, 100vw"
            alt={AZRAHEL.portraitAlt}
          />
        </Reveal>

        <div className={styles.copy}>
          <Reveal>
            <DisplayTitle id="hub-azrahel-title" level={2} size="md" uppercase className={styles.name}>
              <span>{AZRAHEL.nameLead}</span>
              <span className={styles.nameTail}>{AZRAHEL.nameTail}</span>
              <Sparkle className={styles.nameStar} size={14} />
            </DisplayTitle>
          </Reveal>

          <Reveal delay={0.12}>
            <Prose size="sm" className={styles.bio}>
              {AZRAHEL.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </Prose>
          </Reveal>
        </div>

        <span className={styles.geometry} aria-hidden="true">
          <HubCompassRose size={168} />
        </span>
      </div>
    </Section>
  );
}
